export const scheduleStatus = {
  WAITING: { label: "일정 대기", color: "default", tone: "#64748b", bg: "#f1f5f9" },
  CHECK_REQUIRED: { label: "확인 필요", color: "warning", tone: "#b45309", bg: "#fff7ed" },
  CONFIRMED: { label: "계획 확정", color: "success", tone: "#047857", bg: "#ecfdf5" },
  CHANGE_REVIEW: { label: "변경 검토", color: "secondary", tone: "#7c3aed", bg: "#f5f3ff" },
  PLAN_REVIEW: { label: "계획 검토", color: "info", tone: "#0369a1", bg: "#f0f9ff" },
  HOLD: { label: "보류", color: "default", tone: "#475569", bg: "#f8fafc" },
  COMPLETED: { label: "완료", color: "success", tone: "#15803d", bg: "#f0fdf4" },
  CANCELLED: { label: "취소", color: "default", tone: "#6b7280", bg: "#f3f4f6" },
};

export const riskLevel = {
  NORMAL: { label: "정상", color: "success", tone: "#14b8a6", bg: "#ecfeff" },
  ATTENTION: { label: "주의", color: "warning", tone: "#f59e0b", bg: "#fffbeb" },
  HIGH: { label: "고위험", color: "error", tone: "#ef4444", bg: "#fef2f2" },
  OVERDUE: { label: "기한 초과", color: "error", tone: "#991b1b", bg: "#fee2e2" },
};

export const actionType = {
  OVERDUE: "기한 초과",
  HIGH_RISK: "납기 위험",
  CHANGE_REVIEW: "변경 검토",
  CHECK_REQUIRED: "확인 필요",
  PLAN_REVIEW: "생산계획 확인",
  DELIVERY_RISK: "납기 위험 조치",
  CUSTOMER_CHECK: "일정 확인",
};

export const actionStatus = {
  TODO: "처리 대기",
  OPEN: "처리 대기",
  IN_PROGRESS: "재확인 예정",
  NOTE: "기록 저장",
  DONE: "처리 완료",
  CANCELLED: "취소",
};

export const orderStatus = {
  DRAFT: "임시 저장",
  RECEIVED: "주문 접수",
  CONFIRMED: "주문 확정",
  HOLD: "보류",
  COMPLETED: "완료",
  CANCELLED: "취소",
};

export const sourceType = {
  MANUAL: "직접 입력",
  EXCEL: "Excel 업로드",
  ERP: "ERP 연동",
  API: "연동 입력",
};

export const productionPlanStatus = {
  NOT_REVIEWED: "계획 미확정",
  REVIEWING: "계획 검토 중",
  PLANNED: "계획 반영",
  REPLAN_REQUIRED: "재계획 필요",
};

export const changeType = {
  DUE_DATE: "납기 변경",
  QUANTITY: "수량 변경",
  ITEM: "품목 변경",
  SPEC: "규격 변경",
  HOLD: "보류 요청",
  RESUME: "재개 요청",
  OTHER: "기타 변경",
};

export const changeStatus = {
  REQUESTED: "검토 요청",
  REVIEWING: "검토 중",
  APPROVED: "승인",
  APPLIED: "적용 완료",
  REJECTED: "반려",
  CANCELLED: "취소",
};

export const changeField = {
  requested_due_date: "요청 납기",
  order_quantity: "수량",
  item_name_snapshot: "품목명",
  specification_snapshot: "규격",
};

export const historyDomain = {
  ORDER: "주문 상태",
  SCHEDULE: "일정 상태",
  ACTION: "조치",
};

export const displayLabel = (source, value) => {
  const matched = source?.[value];
  if (!matched) return value || "-";
  return typeof matched === "object" ? matched.label || value || "-" : matched;
};
